var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 10.5834C13.0097 10.5834 10.5846 13.0085 10.5846 16.0001C10.5846 18.9916 13.0097 21.4167 16.0013 21.4167C18.9928 21.4167 21.4179 18.9916 21.4179 16.0001C21.4179 13.0085 18.9928 10.5834 16.0013 10.5834Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28384 1.13584C13.0307 0.49354 18.9719 0.49354 24.7188 1.13584C27.8828 1.48946 30.4347 3.98242 30.8061 7.15751C31.4932 13.0325 31.4932 18.9676 30.8061 24.8426C30.4347 28.0177 27.8828 30.5106 24.7188 30.8643C18.9719 31.5066 13.0307 31.5066 7.28384 30.8643C4.11985 30.5106 1.56786 28.0177 1.1965 24.8426C0.509369 18.9676 0.509369 13.0325 1.1965 7.15751C1.56786 3.98242 4.11985 1.48946 7.28384 1.13584ZM24.3346 6.00006C23.4141 6.00006 22.6679 6.74625 22.6679 7.66672C22.6679 8.5872 23.4141 9.33339 24.3346 9.33339C25.2551 9.33339 26.0013 8.5872 26.0013 7.66672C26.0013 6.74625 25.2551 6.00006 24.3346 6.00006ZM8.08461 16.0001C8.08461 11.6278 11.629 8.08339 16.0013 8.08339C20.3735 8.08339 23.9179 11.6278 23.9179 16.0001C23.9179 20.3723 20.3735 23.9167 16.0013 23.9167C11.629 23.9167 8.08461 20.3723 8.08461 16.0001Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstLogo);
export default __webpack_public_path__ + "static/media/instLogo.fb8429ccb2510c4210397af7963cc40e.svg";
export { ForwardRef as ReactComponent };